(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf1-feature-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mv-feature-clip')) return;
  class FeatureClip extends HTMLElement {
    connectedCallback() {
      if (this.startup || this.abort) return;
      this.startup = requestAnimationFrame(() => {
        this.startup = 0;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      this.abort = new AbortController();
      this.videoSlot = this.querySelector('.mv-fc__video');
      this.button = this.querySelector('button');
      this.status = this.querySelector('.mv-fc__error');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.near = false;
      this.manualPaused = false;
      this.userStarted = false;
      this.pending = false;
      this.failed = false;
      this.version = (this.version || 0) + 1;
      this.onMotion = () => {
        if (this.reduced.matches && !this.userStarted) {
          this.video?.pause();
          this.classList.remove('has-frame');
        } else if (this.near) this.loadVideo();
        this.sync();
      };
      this.reduced.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', () => this.sync(), {signal:this.abort.signal});
      this.button?.addEventListener('click', () => {
        if (this.video && !this.video.paused) {
          this.manualPaused = true;
          this.video.pause();
          return;
        }
        if (this.failed) this.clearVideo();
        this.userStarted = true;
        this.manualPaused = false;
        this.loadVideo();
        this.sync();
      }, {signal:this.abort.signal});
      if (this.button) this.button.hidden = false;
      if ('IntersectionObserver' in window) {
        this.preload = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          if (this.near && !this.reduced.matches) this.loadVideo();
        }, {rootMargin:'300px'});
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
          this.sync();
        }, {threshold:[0,.35]});
        this.preload.observe(this);
        this.observer.observe(this);
      } else {
        this.visible = this.near = true;
        if (!this.reduced.matches) this.loadVideo();
      }
    }
    loadVideo() {
      if (this.video || !this.abort) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.videoSlot.append(template.content.cloneNode(true));
      const video = this.video = this.videoSlot.querySelector('video');
      if (!video) return;
      video.muted = video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted','');
      video.setAttribute('playsinline','');
      video.setAttribute('aria-hidden','true');
      video.setAttribute('tabindex','-1');
      const version = this.version;
      const on = (type, callback) => video.addEventListener(type, () => {
        if (version === this.version) callback();
      }, {signal:this.abort.signal});
      on('loadeddata', () => this.sync());
      on('canplay', () => this.sync());
      on('playing', () => {
        this.classList.add('is-playing','has-frame');
        if (this.status) this.status.hidden = true;
        this.updateButton();
        if (!this.visible || document.hidden) video.pause();
      });
      on('pause', () => {
        this.classList.remove('is-playing');
        this.updateButton();
      });
      on('ended', () => {
        this.manualPaused = true;
        this.classList.remove('is-playing');
        this.updateButton();
      });
      on('error', () => {
        this.failed = true;
        this.classList.remove('is-playing','has-frame');
        if (this.status) this.status.hidden = false;
        this.updateButton();
      });
      video.load();
      this.sync();
    }
    sync() {
      if (!this.video) return;
      const play = this.visible && !document.hidden && !this.manualPaused &&
        (this.userStarted || (this.dataset.autoplay === 'true' && !this.reduced.matches));
      if (!play) { this.video.pause(); return; }
      if (this.failed || this.pending || !this.video.paused) return;
      const video = this.video, version = this.version;
      this.pending = true;
      Promise.resolve(video.play()).catch(() => {
        if (version === this.version && this.button) this.button.hidden = false;
      }).finally(() => {
        if (version !== this.version) return;
        this.pending = false;
        this.updateButton();
        if (!this.visible || document.hidden || this.manualPaused) video.pause();
      });
    }
    updateButton() {
      if (!this.button) return;
      const playing = Boolean(this.video && !this.video.paused);
      this.button.hidden = playing && this.dataset.controls !== 'true';
      this.button.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
    }
    clearVideo() {
      this.version++;
      this.pending = false;
      this.video?.pause();
      if (this.video) {
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
      }
      this.video = null;
      this.videoSlot?.replaceChildren();
      this.failed = false;
      this.classList.remove('is-playing','has-frame');
      if (this.status) this.status.hidden = true;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startup);
      this.startup = 0;
      this.abort?.abort();
      this.abort = null;
      this.preload?.disconnect();
      this.observer?.disconnect();
      this.reduced?.removeEventListener('change',this.onMotion);
      this.clearVideo();
    }
  }
  customElements.define('mv-feature-clip', FeatureClip);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf1-image-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
 const setup = root => {
  if (!root || root.dataset.pibReady === 'true') return;
  root.dataset.pibReady = 'true';
  const dialog = root.querySelector('[data-pib-video-dialog]');
  root.querySelectorAll('[data-pib-comparison]').forEach(comparison => {
   const range = comparison.querySelector('[data-pib-comparison-range]');
   if (!range) return;
   const updateComparison = value => {
    const numericValue = Number.isFinite(value) ? value : Number(range.value);
    const clampedValue = Math.min(100, Math.max(0, numericValue));
    range.value = String(clampedValue);
    comparison.style.setProperty('--pib-comparison-position', `${clampedValue}%`);
   };
   const updateFromClientX = clientX => {
    const bounds = comparison.getBoundingClientRect();
    if (!bounds.width) return;
    updateComparison(((clientX - bounds.left) / bounds.width) * 100);
   };
   let demoFrame = 0;
   let demoTimer = 0;
   let demoResolve = null;
   let demoComplete = false;
   let demoObserver = null;
   let demoFallbackCheck = null;
   const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
   const clearDemoVisibilityCheck = () => {
    demoObserver?.disconnect();
    if (!demoFallbackCheck) return;
    window.removeEventListener('scroll', demoFallbackCheck);
    window.removeEventListener('resize', demoFallbackCheck);
    demoFallbackCheck = null;
   };
   const cancelDemo = () => {
    if (demoTimer) window.clearTimeout(demoTimer);
    if (demoFrame) window.cancelAnimationFrame(demoFrame);
    demoTimer = 0;
    demoFrame = 0;
    demoComplete = true;
    clearDemoVisibilityCheck();
    if (root.dataset.pibAutoDemo === 'true') root.dataset.pibAutoDemoState = 'cancelled';
    demoResolve?.();
    demoResolve = null;
   };
   const tweenComparison = (from, to, duration) => new Promise(resolve => {
    if (demoComplete) {
     resolve();
     return;
    }
    demoResolve = resolve;
    const startedAt = performance.now();
    const step = now => {
     if (demoComplete) {
      demoResolve = null;
      resolve();
      return;
     }
     const progress = Math.min(1, (now - startedAt) / duration);
     const eased = progress < .5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
     updateComparison(from + (to - from) * eased);
     if (progress < 1) demoFrame = window.requestAnimationFrame(step);
     else {
      demoFrame = 0;
      demoResolve = null;
      resolve();
     }
    };
    demoFrame = window.requestAnimationFrame(step);
   });
   const playDemo = async () => {
    if (demoComplete || reducedMotion.matches) return;
    root.dataset.pibAutoDemoState = 'playing';
    const initial = Number(range.value);
    const right = Math.min(78, Math.max(58, initial + 28));
    const left = Math.max(18, Math.min(42, initial - 12));
    await tweenComparison(initial, right, 700);
    await tweenComparison(right, left, 850);
    await tweenComparison(left, initial, 600);
    if (!demoComplete) {
     updateComparison(initial);
     demoComplete = true;
     root.dataset.pibAutoDemoState = 'complete';
    }
   };
   const cancelDemoOnIntent = () => cancelDemo();
   range.addEventListener('pointerdown', cancelDemoOnIntent);
   range.addEventListener('keydown', cancelDemoOnIntent);
   range.addEventListener('input', cancelDemoOnIntent);
   if (root.dataset.pibAutoDemo === 'true' && !reducedMotion.matches) {
    root.dataset.pibAutoDemoState = 'waiting';
    const scheduleDemo = () => {
     if (demoComplete || demoTimer) return;
     clearDemoVisibilityCheck();
     root.dataset.pibAutoDemoState = 'scheduled';
     demoTimer = window.setTimeout(() => {
      demoTimer = 0;
      playDemo();
     }, 320);
    };
    if ('IntersectionObserver' in window) {
     demoObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .4)) scheduleDemo();
     }, { threshold: [.4] });
     demoObserver.observe(comparison);
    } else {
     demoFallbackCheck = () => {
      const bounds = comparison.getBoundingClientRect();
      const visibleHeight = Math.max(0, Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0));
      if (bounds.height && visibleHeight / bounds.height >= .4) scheduleDemo();
     };
     window.addEventListener('scroll', demoFallbackCheck, { passive: true });
     window.addEventListener('resize', demoFallbackCheck);
     demoFallbackCheck();
    }
    reducedMotion.addEventListener?.('change', event => {
     if (event.matches) cancelDemo();
    }, { once: true });
   }
   let touchStartX = 0;
   let touchStartY = 0;
   let touchAxis = '';
   range.addEventListener('input', () => updateComparison());
   comparison.addEventListener('touchstart', event => {
    if (event.touches.length !== 1) return;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    touchAxis = '';
   }, { passive: true });
   comparison.addEventListener('touchmove', event => {
    if (event.touches.length !== 1) return;
    const touch = event.touches[0];
    const deltaX = Math.abs(touch.clientX - touchStartX);
    const deltaY = Math.abs(touch.clientY - touchStartY);
    if (!touchAxis && Math.max(deltaX, deltaY) >= 5) touchAxis = deltaX > deltaY ? 'x' : 'y';
    if (touchAxis !== 'x') return;
    event.preventDefault();
    updateFromClientX(touch.clientX);
   }, { passive: false });
   comparison.addEventListener('touchend', () => { touchAxis = ''; }, { passive: true });
   comparison.addEventListener('touchcancel', () => { touchAxis = ''; }, { passive: true });
   updateComparison();
  });
  const openButton = root.querySelector('[data-pib-video-open]');
  const closeButton = root.querySelector('[data-pib-video-close]');
  const video = dialog?.querySelector('video');
  const stopVideo = () => {
   if (!video) return;
   video.pause();
   video.currentTime = 0;
  };
  openButton?.addEventListener('click', () => {
   if (!dialog) return;
   if (typeof dialog.showModal === 'function') dialog.showModal();
   else dialog.setAttribute('open', '');
   video?.play().catch(() => {});
  });
  closeButton?.addEventListener('click', () => {
   if (typeof dialog?.close === 'function') dialog.close();
   else dialog?.removeAttribute('open');
   stopVideo();
  });
  dialog?.addEventListener('click', event => {
   if (event.target !== dialog) return;
   dialog.close();
  });
  dialog?.addEventListener('close', stopVideo);
  const addressItems = Array.from(root.querySelectorAll('[data-pib-address]'));
  const hotspots = Array.from(root.querySelectorAll('[data-pib-hotspot]'));
  let pinnedHotspot = null;
  const closeMapPopups = () => {
   hotspots.forEach(item => {
    item.setAttribute('aria-expanded', 'false');
    const popup = root.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);
    if (popup) popup.hidden = true;
   });
   addressItems.forEach(item => item.classList.remove('is-active'));
  };
  const openMapPopup = hotspot => {
   const addressId = hotspot.dataset.pibAddressId;
   const selectedAddress = addressItems.find(item => item.id === addressId);
   const popup = root.querySelector(`#${CSS.escape(hotspot.getAttribute('aria-controls'))}`);
   closeMapPopups();
   hotspot.setAttribute('aria-expanded', 'true');
   if (popup) popup.hidden = false;
   addressItems.forEach(item => item.classList.toggle('is-active', item === selectedAddress));
  };
  hotspots.forEach(hotspot => {
   hotspot.addEventListener('click', event => {
    event.stopPropagation();
    if (pinnedHotspot === hotspot) {
     pinnedHotspot = null;
     closeMapPopups();
     return;
    }
    pinnedHotspot = hotspot;
    openMapPopup(hotspot);
   });
   const location = hotspot.closest('.pib-map-location');
   location?.addEventListener('mouseenter', () => openMapPopup(hotspot));
   location?.addEventListener('mouseleave', () => {
    if (pinnedHotspot) openMapPopup(pinnedHotspot);
    else closeMapPopups();
   });
  });
  root.querySelectorAll('[data-pib-map-popup]').forEach(popup => popup.addEventListener('click', event => event.stopPropagation()));
  root.addEventListener('click', () => {
   pinnedHotspot = null;
   closeMapPopups();
  });
  root.addEventListener('keydown', event => {
   if (event.key !== 'Escape') return;
   const openHotspot = hotspots.find(item => item.getAttribute('aria-expanded') === 'true');
   pinnedHotspot = null;
   closeMapPopups();
   openHotspot?.focus();
  });
 };
 const initialize = scope => {
  if (scope?.matches?.('[data-pib-root]')) setup(scope);
  scope?.querySelectorAll?.('[data-pib-root]').forEach(setup);
 };
 initialize(document);
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf1-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.handleSlideMouseEnter = this.handleSlideMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleSlideChangeStart = this.handleSlideChangeStart.bind(this);
      this.handleSlideChangeEnd = this.handleSlideChangeEnd.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.currentPlayVideo = null;
      this.currentAdvanceTimer = null;
      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
      this.isInView = false;
      this.isUserHovering = false;
      this.hoverFocusSlide = null;
      this.defaultAdvanceDelay = 6000;
      this.initialized = false;
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get slides() {
      return Array.from(this.querySelectorAll('.swiper-slide'));
    }

    get activeSlide() {
      return this.swiper?.slides?.[this.swiper.activeIndex] || this.querySelector('.swiper-slide-active');
    }

    get currentVideo() {
      return this.activeSlide?.querySelector('yg-video.yg-video-box');
    }

    connectedCallback() {
      if (this.initialized || this.initializationObserver) return;

      const initialize = () => {
        this.initializeCarousel();
      };

      if (!('IntersectionObserver' in window)) {
        initialize();
        return;
      }

      this.initializationObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.initializationObserver.disconnect();
        this.initializationObserver = null;
        initialize();
      }, { rootMargin: '600px 0px' });

      this.initializationObserver.observe(this);
    }

    initializeCarousel() {
      if (this.initialized) return;

      if (typeof window.Swiper !== 'function') {
        window.monvaneLoadSwiper?.();
        const swiperReady = window.monvaneSwiperReady || Promise.resolve(window.Swiper);
        swiperReady.then(() => this.initializeCarousel());
        return;
      }

      this.initialized = true;

      this.swiper = this.initSwiper(this);
      this.transitionSpeed = Number(this.dataset.speed) || 650;
      this.swiper.params.speed = this.transitionSpeed;
      this.swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.18, 0.82, 0.28, 1)';

      this.slides.forEach(slide => {
        slide.addEventListener('mouseenter', this.handleSlideMouseEnter);
      });

      this.addEventListener('mouseleave', this.handleMouseLeave);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.45,
      });
      this.intersectionObserver.observe(this);

      this.swiper.on('slideChangeTransitionStart', this.handleSlideChangeStart);
      this.swiper.on('slideChangeTransitionEnd', this.handleSlideChangeEnd);

      this.updateDockState();
    }

    disconnectedCallback() {
      this.clearAutoAdvance();
      this.initializationObserver?.disconnect();
      this.slides.forEach(slide => {
        slide.removeEventListener('mouseenter', this.handleSlideMouseEnter);
      });
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.intersectionObserver?.disconnect();
    }

    handleIntersection(entries) {
      const [entry] = entries;
      if (!entry) return;

      this.isInView = entry.isIntersecting;

      if (this.isInView) {
        this.updateDockState();
        if (!this.isUserHovering) {
          this.playVideoFn();
        }
        return;
      }

      this.clearAutoAdvance();
      this.pauseAllVideos();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.clearAutoAdvance();
        this.pauseAllVideos();
        return;
      }

      if (this.isInView && !this.isUserHovering) {
        this.playVideoFn();
      }
    }

    handleSlideChangeStart() {
      this.updateDockState();
      this.clearAutoAdvance();
    }

    handleSlideChangeEnd() {
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    handleSlideMouseEnter(event) {
      const slide = event.currentTarget;

      this.isUserHovering = true;
      this.classList.add('is-pointer-driven');
      this.hoverFocusSlide = slide;
      this.clearAutoAdvance();
      this.updateDockState();
      this.playVideoFn(slide.querySelector('yg-video.yg-video-box'));
    }

    handleMouseLeave() {
      this.isUserHovering = false;
      this.classList.remove('is-pointer-driven');
      this.hoverFocusSlide = null;
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    updateDockState() {
      const slides = Array.from(this.swiper?.slides || this.slides);
      const focusSlide = this.isUserHovering && this.hoverFocusSlide
        ? this.hoverFocusSlide
        : slides[this.swiper?.activeIndex] || this.querySelector('.swiper-slide-active');
      const activeIndex = slides.indexOf(focusSlide);

      slides.forEach(slide => {
        slide.classList.remove(
          'is-dock-center',
          'is-dock-near',
          'is-dock-far',
          'is-dock-near-left',
          'is-dock-near-right',
          'is-dock-far-left',
          'is-dock-far-right'
        );
      });

      if (activeIndex < 0) return;

      slides[activeIndex]?.classList.add('is-dock-center');
      slides[activeIndex - 1]?.classList.add('is-dock-near', 'is-dock-near-left');
      slides[activeIndex + 1]?.classList.add('is-dock-near', 'is-dock-near-right');
      slides[activeIndex - 2]?.classList.add('is-dock-far', 'is-dock-far-left');
      slides[activeIndex + 2]?.classList.add('is-dock-far', 'is-dock-far-right');
    }

    pauseAllVideos() {
      this.videoList.forEach(video => {
        video.pauseVideo();
        video.closest('.swiper-slide')?.classList.remove('current-play');
      });

      this.currentPlayVideo = null;
    }

    getPrimaryMediaElement(video) {
      if (!video) return null;

      const selector = window.innerWidth <= 699
        ? '.yg-video-iframe:not(.hide-pc)'
        : '.yg-video-iframe:not(.hide-mobile)';
      const media = video.querySelector(selector) || video.querySelector('.yg-video-iframe');

      return media instanceof HTMLVideoElement ? media : null;
    }

    clearAutoAdvance() {
      if (this.currentAdvanceTimer) {
        window.clearTimeout(this.currentAdvanceTimer);
        this.currentAdvanceTimer = null;
      }

      if (this.currentAdvanceMedia && this.currentAdvanceHandler) {
        this.currentAdvanceMedia.removeEventListener('ended', this.currentAdvanceHandler);
      }

      if (this.currentMetadataMedia && this.currentMetadataHandler) {
        this.currentMetadataMedia.removeEventListener('loadedmetadata', this.currentMetadataHandler);
      }

      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
    }

    scheduleAutoAdvance(video) {
      if (!this.isInView || this.isUserHovering || !this.swiper) return;

      this.clearAutoAdvance();

      const advanceToken = Symbol('video-advance');
      this.currentAdvanceToken = advanceToken;

      const advanceToNext = () => {
        if (this.currentAdvanceToken !== advanceToken || this.isUserHovering || !this.isInView) return;

        this.clearAutoAdvance();
        this.swiper.slideNext(this.transitionSpeed);
      };

      const media = this.getPrimaryMediaElement(video);

      if (!media) {
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
        return;
      }

      if (media.readyState >= 1 && Number.isFinite(media.duration) && media.duration > 0) {
        const remainingDuration = Math.max((media.duration - media.currentTime) * 1000, 1200);

        this.currentAdvanceMedia = media;
        this.currentAdvanceHandler = advanceToNext;
        media.addEventListener('ended', this.currentAdvanceHandler, { once: true });
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, remainingDuration + 180);
        return;
      }

      this.currentMetadataMedia = media;
      this.currentMetadataHandler = () => {
        if (this.currentAdvanceToken !== advanceToken) return;
        this.scheduleAutoAdvance(video);
      };
      media.addEventListener('loadedmetadata', this.currentMetadataHandler, { once: true });
      this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
    }

    playVideoFn(source) {
      const video = source instanceof HTMLElement
        ? source.matches('yg-video.yg-video-box') ? source : source.querySelector('yg-video.yg-video-box')
        : source?.currentTarget || source?.target || this.currentVideo;

      if (!video) return;

      const activeMedia = this.getPrimaryMediaElement(video);
      const needsReplay = activeMedia?.ended;
      const isSameVideo = this.currentPlayVideo === video && !needsReplay;

      if (!isSameVideo) {
        this.pauseAllVideos();
        this.currentPlayVideo = video;
        video.playVideo();
        video.closest('.swiper-slide')?.classList.add('current-play');
      }

      this.updateDockState();

      if (!this.isUserHovering) {
        this.scheduleAutoAdvance(video);
      } else {
        this.clearAutoAdvance();
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-reviews"] && !Shopify.designMode) return;
  try {
    

  class YGReviews extends YGUtils {
      constructor() {
          super()
      }
      connectedCallback() {
        if (this.swiper || this.initializationObserver) return;

        const initialize = () => {
          if (this.swiper) return;

          if (typeof window.Swiper !== 'function') {
            window.monvaneLoadSwiper?.();
            const swiperReady = window.monvaneSwiperReady || Promise.resolve(window.Swiper);
            swiperReady.then(initialize);
            return;
          }

          this.swiper = this.initSwiper(this);
        };

        if (!('IntersectionObserver' in window)) {
          initialize();
          return;
        }

        this.initializationObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.initializationObserver.disconnect();
          this.initializationObserver = null;
          initialize();
        }, { rootMargin: '600px 0px' });

        this.initializationObserver.observe(this);
      }

      disconnectedCallback() {
        this.initializationObserver?.disconnect();
      }
  }
  if (!window.customElements.get('yg-reviews')) {
      window.customElements.define('yg-reviews', YGReviews)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-original-sale"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.handleSlideMouseEnter = this.handleSlideMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleSlideChangeStart = this.handleSlideChangeStart.bind(this);
      this.handleSlideChangeEnd = this.handleSlideChangeEnd.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.currentPlayVideo = null;
      this.currentAdvanceTimer = null;
      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
      this.isInView = false;
      this.isUserHovering = false;
      this.hoverFocusSlide = null;
      this.defaultAdvanceDelay = 6000;
      this.initialized = false;
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get slides() {
      return Array.from(this.querySelectorAll('.swiper-slide'));
    }

    get activeSlide() {
      return this.swiper?.slides?.[this.swiper.activeIndex] || this.querySelector('.swiper-slide-active');
    }

    get currentVideo() {
      return this.activeSlide?.querySelector('yg-video.yg-video-box');
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.swiper = this.initSwiper(this);
      this.transitionSpeed = Number(this.dataset.speed) || 650;
      this.swiper.params.speed = this.transitionSpeed;
      this.swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.18, 0.82, 0.28, 1)';

      this.slides.forEach(slide => {
        slide.addEventListener('mouseenter', this.handleSlideMouseEnter);
      });

      this.addEventListener('mouseleave', this.handleMouseLeave);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.45,
      });
      this.intersectionObserver.observe(this);

      this.swiper.on('slideChangeTransitionStart', this.handleSlideChangeStart);
      this.swiper.on('slideChangeTransitionEnd', this.handleSlideChangeEnd);

      this.updateDockState();
    }

    disconnectedCallback() {
      this.clearAutoAdvance();
      this.slides.forEach(slide => {
        slide.removeEventListener('mouseenter', this.handleSlideMouseEnter);
      });
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.intersectionObserver?.disconnect();
    }

    handleIntersection(entries) {
      const [entry] = entries;
      if (!entry) return;

      this.isInView = entry.isIntersecting;

      if (this.isInView) {
        this.updateDockState();
        if (!this.isUserHovering) {
          this.playVideoFn();
        }
        return;
      }

      this.clearAutoAdvance();
      this.pauseAllVideos();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.clearAutoAdvance();
        this.pauseAllVideos();
        return;
      }

      if (this.isInView && !this.isUserHovering) {
        this.playVideoFn();
      }
    }

    handleSlideChangeStart() {
      this.updateDockState();
      this.clearAutoAdvance();
    }

    handleSlideChangeEnd() {
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    handleSlideMouseEnter(event) {
      const slide = event.currentTarget;

      this.isUserHovering = true;
      this.classList.add('is-pointer-driven');
      this.hoverFocusSlide = slide;
      this.clearAutoAdvance();
      this.updateDockState();
      this.playVideoFn(slide.querySelector('yg-video.yg-video-box'));
    }

    handleMouseLeave() {
      this.isUserHovering = false;
      this.classList.remove('is-pointer-driven');
      this.hoverFocusSlide = null;
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    updateDockState() {
      const slides = Array.from(this.swiper?.slides || this.slides);
      const focusSlide = this.isUserHovering && this.hoverFocusSlide
        ? this.hoverFocusSlide
        : slides[this.swiper?.activeIndex] || this.querySelector('.swiper-slide-active');
      const activeIndex = slides.indexOf(focusSlide);

      slides.forEach(slide => {
        slide.classList.remove(
          'is-dock-center',
          'is-dock-near',
          'is-dock-far',
          'is-dock-near-left',
          'is-dock-near-right',
          'is-dock-far-left',
          'is-dock-far-right'
        );
      });

      if (activeIndex < 0) return;

      slides[activeIndex]?.classList.add('is-dock-center');
      slides[activeIndex - 1]?.classList.add('is-dock-near', 'is-dock-near-left');
      slides[activeIndex + 1]?.classList.add('is-dock-near', 'is-dock-near-right');
      slides[activeIndex - 2]?.classList.add('is-dock-far', 'is-dock-far-left');
      slides[activeIndex + 2]?.classList.add('is-dock-far', 'is-dock-far-right');
    }

    pauseAllVideos() {
      this.videoList.forEach(video => {
        video.pauseVideo();
        video.closest('.swiper-slide')?.classList.remove('current-play');
      });

      this.currentPlayVideo = null;
    }

    getPrimaryMediaElement(video) {
      if (!video) return null;

      const selector = window.innerWidth <= 699
        ? '.yg-video-iframe:not(.hide-pc)'
        : '.yg-video-iframe:not(.hide-mobile)';
      const media = video.querySelector(selector) || video.querySelector('.yg-video-iframe');

      return media instanceof HTMLVideoElement ? media : null;
    }

    clearAutoAdvance() {
      if (this.currentAdvanceTimer) {
        window.clearTimeout(this.currentAdvanceTimer);
        this.currentAdvanceTimer = null;
      }

      if (this.currentAdvanceMedia && this.currentAdvanceHandler) {
        this.currentAdvanceMedia.removeEventListener('ended', this.currentAdvanceHandler);
      }

      if (this.currentMetadataMedia && this.currentMetadataHandler) {
        this.currentMetadataMedia.removeEventListener('loadedmetadata', this.currentMetadataHandler);
      }

      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
    }

    scheduleAutoAdvance(video) {
      if (!this.isInView || this.isUserHovering || !this.swiper) return;

      this.clearAutoAdvance();

      const advanceToken = Symbol('video-advance');
      this.currentAdvanceToken = advanceToken;

      const advanceToNext = () => {
        if (this.currentAdvanceToken !== advanceToken || this.isUserHovering || !this.isInView) return;

        this.clearAutoAdvance();
        this.swiper.slideNext(this.transitionSpeed);
      };

      const media = this.getPrimaryMediaElement(video);

      if (!media) {
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
        return;
      }

      if (media.readyState >= 1 && Number.isFinite(media.duration) && media.duration > 0) {
        const remainingDuration = Math.max((media.duration - media.currentTime) * 1000, 1200);

        this.currentAdvanceMedia = media;
        this.currentAdvanceHandler = advanceToNext;
        media.addEventListener('ended', this.currentAdvanceHandler, { once: true });
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, remainingDuration + 180);
        return;
      }

      this.currentMetadataMedia = media;
      this.currentMetadataHandler = () => {
        if (this.currentAdvanceToken !== advanceToken) return;
        this.scheduleAutoAdvance(video);
      };
      media.addEventListener('loadedmetadata', this.currentMetadataHandler, { once: true });
      this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
    }

    playVideoFn(source) {
      const video = source instanceof HTMLElement
        ? source.matches('yg-video.yg-video-box') ? source : source.querySelector('yg-video.yg-video-box')
        : source?.currentTarget || source?.target || this.currentVideo;

      if (!video) return;

      const activeMedia = this.getPrimaryMediaElement(video);
      const needsReplay = activeMedia?.ended;
      const isSameVideo = this.currentPlayVideo === video && !needsReplay;

      if (!isSameVideo) {
        this.pauseAllVideos();
        this.currentPlayVideo = video;
        video.playVideo();
        video.closest('.swiper-slide')?.classList.add('current-play');
      }

      this.updateDockState();

      if (!this.isUserHovering) {
        this.scheduleAutoAdvance(video);
      } else {
        this.clearAutoAdvance();
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.handleSlideMouseEnter = this.handleSlideMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleSlideChangeStart = this.handleSlideChangeStart.bind(this);
      this.handleSlideChangeEnd = this.handleSlideChangeEnd.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.currentPlayVideo = null;
      this.currentAdvanceTimer = null;
      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
      this.isInView = false;
      this.isUserHovering = false;
      this.hoverFocusSlide = null;
      this.defaultAdvanceDelay = 6000;
      this.initialized = false;
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get slides() {
      return Array.from(this.querySelectorAll('.swiper-slide'));
    }

    get activeSlide() {
      return this.swiper?.slides?.[this.swiper.activeIndex] || this.querySelector('.swiper-slide-active');
    }

    get currentVideo() {
      return this.activeSlide?.querySelector('yg-video.yg-video-box');
    }

    connectedCallback() {
      if (this.initialized || this.initializationObserver) return;

      const initialize = () => {
        this.initializeCarousel();
      };

      if (!('IntersectionObserver' in window)) {
        initialize();
        return;
      }

      this.initializationObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.initializationObserver.disconnect();
        this.initializationObserver = null;
        initialize();
      }, { rootMargin: '600px 0px' });

      this.initializationObserver.observe(this);
    }

    initializeCarousel() {
      if (this.initialized) return;

      if (typeof window.Swiper !== 'function') {
        window.monvaneLoadSwiper?.();
        const swiperReady = window.monvaneSwiperReady || Promise.resolve(window.Swiper);
        swiperReady.then(() => this.initializeCarousel());
        return;
      }

      this.initialized = true;

      this.swiper = this.initSwiper(this);
      this.transitionSpeed = Number(this.dataset.speed) || 650;
      this.swiper.params.speed = this.transitionSpeed;
      this.swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.18, 0.82, 0.28, 1)';

      this.slides.forEach(slide => {
        slide.addEventListener('mouseenter', this.handleSlideMouseEnter);
      });

      this.addEventListener('mouseleave', this.handleMouseLeave);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.45,
      });
      this.intersectionObserver.observe(this);

      this.swiper.on('slideChangeTransitionStart', this.handleSlideChangeStart);
      this.swiper.on('slideChangeTransitionEnd', this.handleSlideChangeEnd);

      this.updateDockState();
    }

    disconnectedCallback() {
      this.clearAutoAdvance();
      this.initializationObserver?.disconnect();
      this.slides.forEach(slide => {
        slide.removeEventListener('mouseenter', this.handleSlideMouseEnter);
      });
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.intersectionObserver?.disconnect();
    }

    handleIntersection(entries) {
      const [entry] = entries;
      if (!entry) return;

      this.isInView = entry.isIntersecting;

      if (this.isInView) {
        this.updateDockState();
        if (!this.isUserHovering) {
          this.playVideoFn();
        }
        return;
      }

      this.clearAutoAdvance();
      this.pauseAllVideos();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.clearAutoAdvance();
        this.pauseAllVideos();
        return;
      }

      if (this.isInView && !this.isUserHovering) {
        this.playVideoFn();
      }
    }

    handleSlideChangeStart() {
      this.updateDockState();
      this.clearAutoAdvance();
    }

    handleSlideChangeEnd() {
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    handleSlideMouseEnter(event) {
      const slide = event.currentTarget;

      this.isUserHovering = true;
      this.classList.add('is-pointer-driven');
      this.hoverFocusSlide = slide;
      this.clearAutoAdvance();
      this.updateDockState();
      this.playVideoFn(slide.querySelector('yg-video.yg-video-box'));
    }

    handleMouseLeave() {
      this.isUserHovering = false;
      this.classList.remove('is-pointer-driven');
      this.hoverFocusSlide = null;
      this.updateDockState();

      if (this.isInView) {
        this.playVideoFn();
      }
    }

    updateDockState() {
      const slides = Array.from(this.swiper?.slides || this.slides);
      const focusSlide = this.isUserHovering && this.hoverFocusSlide
        ? this.hoverFocusSlide
        : slides[this.swiper?.activeIndex] || this.querySelector('.swiper-slide-active');
      const activeIndex = slides.indexOf(focusSlide);

      slides.forEach(slide => {
        slide.classList.remove(
          'is-dock-center',
          'is-dock-near',
          'is-dock-far',
          'is-dock-near-left',
          'is-dock-near-right',
          'is-dock-far-left',
          'is-dock-far-right'
        );
      });

      if (activeIndex < 0) return;

      slides[activeIndex]?.classList.add('is-dock-center');
      slides[activeIndex - 1]?.classList.add('is-dock-near', 'is-dock-near-left');
      slides[activeIndex + 1]?.classList.add('is-dock-near', 'is-dock-near-right');
      slides[activeIndex - 2]?.classList.add('is-dock-far', 'is-dock-far-left');
      slides[activeIndex + 2]?.classList.add('is-dock-far', 'is-dock-far-right');
    }

    pauseAllVideos() {
      this.videoList.forEach(video => {
        video.pauseVideo();
        video.closest('.swiper-slide')?.classList.remove('current-play');
      });

      this.currentPlayVideo = null;
    }

    getPrimaryMediaElement(video) {
      if (!video) return null;

      const selector = window.innerWidth <= 699
        ? '.yg-video-iframe:not(.hide-pc)'
        : '.yg-video-iframe:not(.hide-mobile)';
      const media = video.querySelector(selector) || video.querySelector('.yg-video-iframe');

      return media instanceof HTMLVideoElement ? media : null;
    }

    clearAutoAdvance() {
      if (this.currentAdvanceTimer) {
        window.clearTimeout(this.currentAdvanceTimer);
        this.currentAdvanceTimer = null;
      }

      if (this.currentAdvanceMedia && this.currentAdvanceHandler) {
        this.currentAdvanceMedia.removeEventListener('ended', this.currentAdvanceHandler);
      }

      if (this.currentMetadataMedia && this.currentMetadataHandler) {
        this.currentMetadataMedia.removeEventListener('loadedmetadata', this.currentMetadataHandler);
      }

      this.currentAdvanceMedia = null;
      this.currentAdvanceHandler = null;
      this.currentMetadataMedia = null;
      this.currentMetadataHandler = null;
      this.currentAdvanceToken = null;
    }

    scheduleAutoAdvance(video) {
      if (!this.isInView || this.isUserHovering || !this.swiper) return;

      this.clearAutoAdvance();

      const advanceToken = Symbol('video-advance');
      this.currentAdvanceToken = advanceToken;

      const advanceToNext = () => {
        if (this.currentAdvanceToken !== advanceToken || this.isUserHovering || !this.isInView) return;

        this.clearAutoAdvance();
        this.swiper.slideNext(this.transitionSpeed);
      };

      const media = this.getPrimaryMediaElement(video);

      if (!media) {
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
        return;
      }

      if (media.readyState >= 1 && Number.isFinite(media.duration) && media.duration > 0) {
        const remainingDuration = Math.max((media.duration - media.currentTime) * 1000, 1200);

        this.currentAdvanceMedia = media;
        this.currentAdvanceHandler = advanceToNext;
        media.addEventListener('ended', this.currentAdvanceHandler, { once: true });
        this.currentAdvanceTimer = window.setTimeout(advanceToNext, remainingDuration + 180);
        return;
      }

      this.currentMetadataMedia = media;
      this.currentMetadataHandler = () => {
        if (this.currentAdvanceToken !== advanceToken) return;
        this.scheduleAutoAdvance(video);
      };
      media.addEventListener('loadedmetadata', this.currentMetadataHandler, { once: true });
      this.currentAdvanceTimer = window.setTimeout(advanceToNext, this.defaultAdvanceDelay);
    }

    playVideoFn(source) {
      const video = source instanceof HTMLElement
        ? source.matches('yg-video.yg-video-box') ? source : source.querySelector('yg-video.yg-video-box')
        : source?.currentTarget || source?.target || this.currentVideo;

      if (!video) return;

      const activeMedia = this.getPrimaryMediaElement(video);
      const needsReplay = activeMedia?.ended;
      const isSameVideo = this.currentPlayVideo === video && !needsReplay;

      if (!isSameVideo) {
        this.pauseAllVideos();
        this.currentPlayVideo = video;
        video.playVideo();
        video.closest('.swiper-slide')?.classList.add('current-play');
      }

      this.updateDockState();

      if (!this.isUserHovering) {
        this.scheduleAutoAdvance(video);
      } else {
        this.clearAutoAdvance();
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();
})();
